import bms from "../res/LogoBMS.png";
import bmsWhite from "../res/LogoBMSWhite.png";
import termBMS from "../res/termo_consentimento_bms.pdf";

export function getLogo() {
  return bms;
}

export function getLogoWhite() {
  return bmsWhite;
}

export function getTermoConsentimento() {
  return termBMS;
}

export function getEmail() {
  return "aposentadoria.falecom@bmsassociados.adv.br";
}

export function getPhone() {
  return "0800 6422272";
}

export function getCompanyName(short = false) {
  if (short) {
    return "BMS";
  }
  return "BMS Aposentadorias e Revisões";
}
